import { css, StyleSheet } from 'aphrodite';
import { useEffect, useState } from 'react';
import { useAuth, withAuthenticationRequired } from 'react-oidc-context';
import { ToastContainer } from 'react-toastify';
import { Segment, Sidebar as SemanticSidebar } from 'semantic-ui-react';

import { validate } from '../../application/security/auth';

import Header from './Header';
import MissingPermissionsPage from './MissingPermissionsPage';
import Sidebar from './Sidebar';

interface DefaultLayoutProps {
    requiredPermission?: string;
    children?: React.ReactNode;
}

const styles = StyleSheet.create({
    tallDivs: {
        minHeight: '95vh',
    },
});

export function DefaultLayout(props: DefaultLayoutProps) {
    const auth = useAuth();
    const isPermitted = validate(props.requiredPermission, auth);
    const [loginAttempted, setLoginAttempted] = useState(false);

    useEffect(() => {
        if (!loginAttempted) {
            setLoginAttempted(true);
            auth.signinSilent().then((value) => {
                if (value === null) {
                    auth.removeUser();
                }
            });
        }
    }, [auth, loginAttempted]);

    return (
        <div>
            <div>
                <Header />
                <ToastContainer autoClose={7500} />
            </div>
            <div>
                <SemanticSidebar.Pushable as={Segment} className={css(styles.tallDivs)}>
                    <Sidebar />
                    <SemanticSidebar.Pusher>
                        {isPermitted ? (
                            props.children
                        ) : (
                            <MissingPermissionsPage requiredPermission={props.requiredPermission} />
                        )}
                    </SemanticSidebar.Pusher>
                </SemanticSidebar.Pushable>
            </div>
        </div>
    );
}

export default withAuthenticationRequired(DefaultLayout, {
    OnRedirecting: () => <div>Redirecting to the login page...</div>,
});
